// Common aspect ratios
export const ratios = {
    paperAPortrait: 1 / Math.SQRT2,
    media: 16 / 9,
    academy: 1.375, // https://en.wikipedia.org/wiki/Academy_ratio
};
